export class NotificationData {
  public Header: string;
  public Notification: string;
}
